<div class="card flex justify-content-center">
  <span class="toggle-btn" (click)="op.toggle($event)">Toggle feature</span>

  <p-popover #op>
    @if ((toggleFeatureSelect$ | async); as toggleFeatureView) {
      <div class="flex flex-column gap-3 w-25rem toggle-feature-container">
        <div>
          <div class="menu-items">
            <div class="menu-item">
              <span>Afficher les menus/boutons non implémentés</span>
              <p-toggleswitch  (onChange)="updateAllItems($event)"
                [(ngModel)]="toggleFeatureView.displayNonImplementedMenus" />
            </div>
            <p-divider />
            <div class="menu-item">
              <span>Demande d'export (pour les développeurs)</span>
              <p-toggleswitch  (onChange)="updateDevelopmentItems($event)"
                [(ngModel)]="toggleFeatureView.displayDevelopmentItems" />
            </div>
          </div>
        </div>
      </div>
    }
  </p-popover>
</div>
